// Datentyp nicht relevant

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TealiumTrackingService } from './services/tealium-tracking.service';
import { UtagHelperService } from './services/utag-helper.service';

@NgModule({
  declarations: [],
  exports: [],
  imports: [CommonModule],
  providers: [TealiumTrackingService, UtagHelperService],
})
export class CoreModule {}
